<template>
  <div class="upgrade-box">
    <div class="ceiling">
      <home-top></home-top>
    </div>
    <div class="content">
      <div class="upgrade-container">
        <!-- 页面标题 -->
        <div class="page-title">
          <h1>会员升级</h1>
          <p>升级会员，享受更多专属特权</p>
        </div>

        <!-- 会员卡片对比 -->
        <div class="membership-cards">
          <div class="membership-rules">
            <h2>会员计算规则</h2>
            <div class="rules-content">
              <div class="rule-item">
                <h3>1. 会员有效期计算</h3>
                <p>会员有效期从支付成功之日起计算，为期12个月。</p>
              </div>
              <div class="rule-item">
                <h3>2. 会员升级计算</h3>
                <p>已开通VIP会员的用户，升级至SVIP会员时，将根据VIP剩余有效期进行差价计算。计算公式：超级 VIP 全年总费用 -
                  （VIP 单日价值 × 剩余天数）。<p class="big-fun">SVIP总价值{{
                      configInfo.svip_acount
                    }}元/年，现有vip可抵扣{{ upInfo.discount }}元，实际应付{{ upInfo.price }}元。 </p></p>
              </div>
              <div class="rule-item">
                <h3>3. 金额说明</h3>
                <p>所有会员价格均为含税价，开具增值税普通发票。企业用户可提供相关资料申请增值税专用发票。</p>
              </div>
              <div class="rule-item">
                <h3>4. 退款政策</h3>
                <p>会员开通后不支持退款。如有特殊情况，请联系客服处理。</p>
              </div>
            </div>
          </div>

          <!-- SVIP会员卡片 -->
          <div class="membership-card svip-card">
            <div class="card-header">
              <div class="card-badge hot">SVIP超级会员</div>
              <div class="card-price">
                <span class="price">¥{{ upInfo.price }}</span>
                <span class="period">/年</span>
              </div>
            </div>
            <div class="card-body">
              <ul class="privilege-list">
                <li class="privilege-item" v-for="feature in vipConfig.levels.svip.features" :key="feature"> ✓
                  {{ feature }}
                </li>
              </ul>
            </div>
            <div class="card-footer">
              <button class="upgrade-btn svip-btn" @click="upgradeToSVIP">立即升级</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        width="30%"
        center>
      <div class="new-payment-section">
        <div class="pay-body">
          <div class="pay-item">
            <div class="pay-item-title">
              <!--                  <span :class="['pay-type', { active: selectedPayType === 'alipay' }]" @click="selectPay('alipay')">-->
              <!--                    支付宝支付-->
              <!--                  </span>-->
              <span :class="['pay-type', { active: selectedPayType === 'wechat' }]" @click="selectPay('wechat')">
                    微信支付
                  </span>
              <span :class="['pay-type', { active: selectedPayType === 'lineDown' }]"
                    @click="selectPay('lineDown')">
                    线下汇款
                  </span>

            </div>
          </div>
          <div class="pay-code">
            <div class="pay-code-title">
              支付金额：{{ upInfo.price }}元
            </div>
            <div v-if="selectedPayType != 'lineDown'">
              <div v-if="codeLoading" class=" sizre-20">
                <i class="el-icon-loading"></i>
              </div>
              <canvas class="qrcode" id="qrcode" ref="qrcode"></canvas>
            </div>
            <div class="pay-code-tip" v-if="selectedPayType != 'lineDown'">
              请使用
              <span class="pay-code-tip-text">{{
                  selectedPayType === "wechat" ? "微信" : "微信"
                }}</span>
              扫描二维码完成支付
            </div>
            <div class="pay-code-tip" v-if="selectedPayType != 'lineDown'">
              支付后关闭弹窗跳转至首页即可
            </div>
            <div v-else class="pay-inner">
              <!-- <div class="pay-code-title"> 支付金额：{{ detail.total_price || total_price }}元</div> -->
              <el-form v-model="formData" :rules="formRules" class="pay-form" label-width="100px" ref="formRules">
                <el-form-item label="汇款方式">
                  <el-radio-group v-model="formData.pay_type" prop="pay_type">
                    <el-radio label="remit_alipay">支付宝汇款</el-radio>
                    <el-radio label="remit_bank">银行汇款</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="支付宝二维码" v-if="formData.pay_type == 'remit_alipay'">
                  <el-image style="width: 120px; height: 120px" :src="configInfo.pay_alipay"
                            fit="scale-down"></el-image>
                </el-form-item>
                <div v-else>

                  <el-form-item label="账户名称">
                    {{ configInfo.pay_name }}
                    <el-button class="copy-btn" type="text" @click="handleCopy(configInfo.pay_name)">
                      <i class="el-icon-copy-document"></i></el-button>
                  </el-form-item>
                  <el-form-item label="银行帐号">
                    {{ configInfo.pay_bank }}
                    <el-button class="copy-btn" type="text" @click="handleCopy(configInfo.pay_bank)">
                      <i class="el-icon-copy-document"></i></el-button>
                  </el-form-item>
                  <el-form-item label="开户行">
                    {{ configInfo.pay_account }}
                    <el-button class="copy-btn" type="text" @click="handleCopy(configInfo.pay_account)">
                      <i class="el-icon-copy-document"></i></el-button>
                  </el-form-item>

                </div>
                <el-form-item label="汇款凭证" v-model="formData.pay_image" prop="pay_image">
                  <ImageUpload :maxCount="1" @change="changeImage"></ImageUpload>
                </el-form-item>
              </el-form>
              <el-button type="primary" class="button-style" @click="save">
                提交
              </el-button>
            </div>

            <div class="login-box-text">
              <el-checkbox v-model="disAgree" @change="changeAgree">
                已阅读并同意
                <span class="agreement-link" @click="showAgreement(3)">《SVIP会员协议》</span>和<span
                  class="agreement-link" @click="showAgreement(15)">《SVIP合同》</span>
              </el-checkbox>

            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <home-footer></home-footer>
  </div>
</template>
<script>
import homeTop from "@/components/public/home-top.vue";
import HomeFooter from "@/components/public/home-footer.vue";
import {mapGetters} from 'vuex';
import VIP_CONFIG from '@/config/vipConfig';
import QRCode from "qrcode";
import {getUpgradeSvipPrice, unifiedPayment} from '@/api/modules/user';
import ImageUpload from "@/components/public/ImageUpload.vue";
import {member} from "@/api";

export default {
  name: "upgrade",
  components: {ImageUpload, HomeFooter, homeTop},
  data() {
    return {
      centerDialogVisible: false,
      vipConfig: VIP_CONFIG,
      upInfo: {},
      selectedPayType: '',
      codeLoading: false,
      formData: {
        pay_type: "remit_alipay",
        pay_image: []
      },
      pollingInterval: null,
      order_id: '',
      disAgree: false,
      formRules: {
        pay_image: [
          {required: true, message: '请上传汇款凭证', trigger: 'blur'}
        ]
      },
    }
  },
  onUnmounted() {
    this.stopPolling()
  },
  computed: {
    ...mapGetters(['userInfo']),
    configInfo() {
      return this.$store.state.config.config;
    },
  },
  created() {
    this.getSvipPrice();
    this.generateOrder();
  },
  methods: {
    showAgreement(id) {
      this.$router.push('/agreement/agreement?id=' + id);
    },
    // 点击是否同意协议
    changeAgree(val) {
      this.disAgree = val;
      if (val) {
        if (this.selectedPayType === 'wechat') {
          this.selectPay()
        }
      }
    },
    // 线下支付提交成功
    save() {
      if (this.formData.pay_image.length == 0) {
        this.$message.error({
          message: '请上传汇款凭证',
          offset: 300
        })
        return
      }
      if (this.formData.pay_type && this.formData.pay_image) {
        unifiedPayment({
          pay_type: this.formData.pay_type,
          pay_image: this.formData.pay_image,
          order_id: this.order_id,
          form_field: 'member'
        }).then(res => {
          if (res.data.code == 10000) {
            this.$message.success(
                {
                  message: res.data.message,
                  offset: 300
                }
            )
            this.$store.dispatch('GET_USER_INFO')
            this.$router.push({path: '/vip/svipSuc'})
          }
        })

      } else {
        this.$message.error({
          message: '请完善信息后提交！',
          offset: 300
        })
      }
    },

    handleCopy(text) {
      this.$utils.copyText(text).then(res => {
        this.$message.success('复制成功');
      })
    },
    // 上传图片
    changeImage(e) {
      this.formData.pay_image = e[0]
    },
    async selectPay(type) {
      if (!this.mixCheckUserAudit()) {
        return
      }
      if (!this.disAgree) {
        this.$message.error({
          message: '请阅读并同意vip会员协议和vip合同',
          offset: 300,
          duration: 500
        })
        return
      }

      this.selectedPayType = type;
      if (type == 'lineDown') {
        return
      }
      let data = {
        pay_type: this.selectedPayType == 'wechat' ? 'wechat_native' : 'alipay',
        order_id: this.order_id,
        form_field: 'member',
        level: 2, // 添加等级参数
      };
      this.codeLoading = true;
      let res = await unifiedPayment(data)
      if (res.data.code === 10000) {
        if (this.selectedPayType === "wechat") {
          this.getCode(res.data.data.code_url);
        } else {
          this.getCode(res.data.data.qr_code);
        }
      } else {
        this.$message.error(res.data.message);
      }
    },
    async getCode(url) {
      try {
        await QRCode.toCanvas(this.$refs.qrcode, url, {
          width: 200,
          margin: 2,
          color: "#000000",
          background: "#ffffff",
        });
        this.codeLoading = false;
        this.startPolling()
      } catch (err) {
        console.error("生成二维码失败:", err);
      }
    },
    // 获取SVIP价格
    getSvipPrice() {
      getUpgradeSvipPrice().then((res) => {
        if (res.data.code == 10000) {
          this.upInfo = res.data.data;
        }
      });
    },
    // 升级到VIP
    async generateOrder() {
      // 根据选择的等级生成订单
      let res = await member({member_type: 2});
      this.order_id = res.data.data;
    },

    // 升级到SVIP
    upgradeToSVIP() {
      this.centerDialogVisible = true;
    },

    startPolling() {
      if (!this.pollingInterval) {
        this.pollingInterval = setInterval(() => {
          this.$store.dispatch('GET_USER_INFO')
          if (this.userInfo.vip_status === 1 && this.userInfo.member_type === 2) {
            this.stopPolling()
          }
        }, 3000);
      }
    },

    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
        this.$router.replace({path: '/vip/svipSuc'})
      }
    },
  }
}
</script>

<style scoped lang="scss">
.big-fun {
  font-weight: bold;
  color: #FF4D4F !important;
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 62px);
  background: url('../../../static/index/message-bj.png');
  background-size: 100% 100%;

}

.upgrade-container {
  width: 100%;
  max-width: 1200px;
  //background: rgba(255, 255, 255, 0.95);
  //border-radius: 10px;
  //box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.page-title {
  text-align: center;
  margin-bottom: 40px;
}

.page-title h1 {
  font-size: 32px;
  color: #333;
  margin-bottom: 10px;
}

.page-title p {
  font-size: 16px;
  color: #666;
}

.membership-cards {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
}

.membership-card {
  width: 350px;
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}


.svip-card {
  border: 2px solid #FF9800;
  background: linear-gradient(135deg, #fff9f0, #ffffff);
  transform: scale(1.05);
}

.membership-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.card-header {
  padding: 25px;
  text-align: center;
  position: relative;
}


.svip-card .card-header {
  background: linear-gradient(135deg, #FF9800, #f57c00);
  color: white;
}

.card-badge {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
}


.card-price {
  font-size: 28px;
  font-weight: bold;
}

.card-price .period {
  font-size: 16px;
  font-weight: normal;
  margin-left: 5px;
}

.card-body {
  padding: 25px;
}

.privilege-list {
  list-style: none;
  padding: 0;
}

.privilege-item {
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  color: #333;
  font-size: 14px;
}

.privilege-item:last-child {
  border-bottom: none;
}

.card-footer {
  padding: 20px 25px;
  text-align: center;
}

.upgrade-btn {
  padding: 12px 30px;
  border: none;
  border-radius: 30px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.vip-btn {
  background: #4CAF50;
  color: white;
}

.vip-btn:hover {
  background: #45a049;
  transform: translateY(-2px);
}

.svip-btn {
  background: #FF9800;
  color: white;
}

.svip-btn:hover {
  background: #f57c00;
  transform: translateY(-2px);
}

.membership-rules,
.faq-section {
  width: 60%;
  margin-bottom: 40px;
}

.membership-rules h2,
.faq-section h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
}

.rules-content,
.faq-content {
  padding: 0 10px;
}

.rule-item,
.faq-item {
  margin-bottom: 20px;
}

.rule-item h3,
.faq-question {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.rule-item p,
.faq-answer {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

.contact-service {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  font-size: 14px;
  color: #666;
}

.service-phone,
.service-email {
  color: #4CAF50;
  font-weight: bold;
}

.new-payment-section {
  width: 100%;
  max-width: 600px;

  h3 {
    font-size: 26px;
    color: #333d4b;
    margin-bottom: 30px;
    text-align: center;
    font-weight: 600;
  }

  .pay-item-title {
    display: flex;
    justify-content: center;
    gap: 32px;
    margin: 32px 0 24px 0;
  }

  .qrcode {
    width: 200px;
    height: 200px;
  }

  .pay-type {
    padding: 12px 36px;
    border: 2px solid #e0e0e0;
    border-radius: 28px;
    cursor: pointer;
    font-size: 18px;
    color: #666;
    background: #f7faff;
    transition: all 0.2s;
    user-select: none;
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(12, 96, 230, 0.04);
  }

  .pay-type.active {
    border-color: #0c60e6;
    background: #e8ebf5;
    color: #0c60e6;
    font-weight: bold;
    box-shadow: 0 4px 16px rgba(12, 96, 230, 0.1);
  }

  .pay-type:not(.active):hover {
    border-color: #bdbdbd;
    background: #f0f4fa;
  }

  .pay-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 32px;
    margin-bottom: 24px;
  }

  .pay-code canvas {
    border: 1.5px solid #e0e0e0;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(12, 96, 230, 0.08);
    background: #fff;
    padding: 12px;
  }

  .pay-code-tip {
    margin-top: 16px;
    color: #888;
    font-size: 15px;
    letter-spacing: 1px;
  }

  .pay-code-title {
    font-size: 22px;
    color: #0c60e6;
    font-weight: bold;
    margin-bottom: 18px;
    text-align: center;
    letter-spacing: 1px;
  }

  .sizre-20 {
    font-size: 40px;
    position: absolute;
    line-height: 212px;
    display: flex;
    justify-content: center;
    /* 水平居中 */
    align-items: center;
    padding-left: 10px;
    /* 垂直居中 */
    width: 212px;
    height: 212px;
    background: #ffffff;
    border-radius: 24px;
    opacity: 0.8;
  }

  .login-box-text {
    margin-top: 20px;
  }

  .agreement-link {
    color: #667eea;
    cursor: pointer;
    // text-decoration: underline;
  }

  .pay-inner {
    background: #fff;
    padding: 20px 30px;
    border-radius: 10px;

    .button-style {
      width: 100%;
    }
  }
}

</style>
